module.exports = __webpack_public_path__ + "static/media/Pool3.11c2ddb4.jpg";